import React from "react";
import PropTypes from "prop-types";
import { FormSpy } from "react-final-form";

import { composeValidators, email, required } from "../helpers/formValidators";

import { BaseForm, FormInput } from "./form";

import { PrimaryButton } from "./buttons";
import "./ForgotPassword.css";

function ForgotPassword(props) {
  const {
    isIncorrectEmailMessageVisible,
    isSuccessMessageVisible,
    onRequestClose,
    onSubmit,
    t,
  } = props;

  return (
    <div>
      <div className="page-header">
        <h3>Reset Password</h3>
      </div>
      <div className="forgot-password-container container">
        {isSuccessMessageVisible || isIncorrectEmailMessageVisible ? (
          <div className="forgot-password-success-message">
            <p>
              <strong>
                We've sent an email with instructions on how to reset
                your&nbsp;password.
              </strong>
            </p>
            <p className="note">
              Please note that it can take up up to 30&nbsp;minutes
              to&nbsp;arrive.
            </p>
            <div className="content-additional">
              <p>If you don't receive an email:</p>
              <ul>
                <li>Check your spam folder</li>
                <li>Double check the email spelling and try again</li>
                <li>The email might not be in our system</li>
              </ul>
            </div>
            <div className="forgot-password-container__footer">
              <PrimaryButton
                colorScheme="blue"
                label={t("modal.close")}
                onClick={onRequestClose}
              />
            </div>
          </div>
        ) : (
          <BaseForm className="forgot-password-form" onSubmit={onSubmit}>
            <p>
              Enter your email below and we'll send you instructions on how to
              reset it.
            </p>

            <FormInput
              validate={composeValidators(required, email)}
              id="forgotPassword.email"
              name="email"
              placeholder="email@example.com"
              type="email"
            />

            <div className="forgot-password-container__footer">
              <FormSpy subscription={{ invalid: true, submitting: true }}>
                {({ invalid, submitting }) => (
                  <PrimaryButton
                    type="submit"
                    label="Send"
                    disabled={invalid || submitting}
                  />
                )}
              </FormSpy>
            </div>
          </BaseForm>
        )}
      </div>
    </div>
  );
}

ForgotPassword.propTypes = {
  isIncorrectEmailMessageVisible: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  isSuccessMessageVisible: PropTypes.bool,
  isButtonDisabled: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  onSubmit: PropTypes.func,
  t: PropTypes.func,
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js